import { CommonConstant, CampaignInfluencerStatus } from '../../app.constants';
import { CampaignService } from '../../services/campaign/campaign.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { NewCampaignTabs } from '../../../models/campaign';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { CommunicationService } from '../../services/communication/communication.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { PdfViewerService } from '../pdf-viewer/pdf-viewer.service';
import { ModalService } from '../../services/modal/modal.service';
import { AppSettings } from '../../utils/app-settings';
import { RequestInfluencerType } from '../../../models/influencer';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActionDetails, ActionSource, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
import * as Sentry from '@sentry/browser';
import { InfluencerRequestError } from '../../influencer-platform/influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component';
import { InfluencerStatus } from '../../../models/influencer/new-influencer';
import { AuthService } from '../../core/auth.service';
var CampaignNewComponent = /** @class */ (function () {
    function CampaignNewComponent(newCampaignService, influencerService, communicationService, pdfViewerService, modalService, router, location, activatedRoute, userService, eventTracker, deviceService, auth) {
        this.newCampaignService = newCampaignService;
        this.influencerService = influencerService;
        this.communicationService = communicationService;
        this.pdfViewerService = pdfViewerService;
        this.modalService = modalService;
        this.router = router;
        this.location = location;
        this.activatedRoute = activatedRoute;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.deviceService = deviceService;
        this.auth = auth;
        this.selectedTab = NewCampaignTabs.CAMPAIGN;
        this.showActivityLog = true;
        this.slider = [
            { i: 0, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name, selected: false },
            { i: 1, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name, selected: false },
            { i: 2, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name, selected: false },
            { i: 3, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name, selected: false }
        ];
        this.updateSlider('');
    }
    CampaignNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.params.subscribe(function (params) {
            _this.campaignId = Number(params.campaignId);
        });
        this.activatedRoute.queryParams.subscribe(function (qp) {
            _this.isNewCampaign = qp.isNewCampaign;
            if (qp.inviteToken && AppSettings.isActiveNewCampaignFlow()) {
                _this.inviteToken = qp.inviteToken;
                _this.hideSideBar();
            }
            if (qp.isReAccept) {
                _this.isReAccept = Boolean(qp.isReAccept);
            }
        });
        this.currentInfluencer = this.userService.getInfluencerInfo();
        if (this.currentInfluencer) {
            this.retrieveCampaignInvitationData(this.currentInfluencer, this.campaignId, this.deviceService.isMobile());
            this.checkInfluencerStatus(this.currentInfluencer);
        }
        else {
            this.showErrorPopup(InfluencerRequestError.CAMPAIGN_INVITATION_DELETE);
            this.sendMixpanelEvent(ActionDetails.INFLUENCER_REQUEST_DELETE);
        }
    };
    CampaignNewComponent.prototype.ngOnDestroy = function () {
        if (AppSettings.isActiveNewCampaignFlow()) {
            this.showSideBar();
        }
    };
    CampaignNewComponent.prototype.checkInfluencerStatus = function (influencer) {
        if (influencer.isActive === InfluencerStatus.INACTIVE || influencer.isActive === InfluencerStatus.DELETED) {
            this.influencerService.activeInfluencer(influencer.id).subscribe();
        }
    };
    CampaignNewComponent.prototype.checkInfluencerConfirmation = function (influencer) {
        if (influencer && !influencer.acceptedTermService) {
            this.auth.needAcceptedTermAndCondition();
        }
    };
    CampaignNewComponent.prototype.retrieveCampaignInvitationData = function (influencer, campaignId, isMobile) {
        var _this = this;
        this.newCampaignService.getCampaignOfInfluencer(influencer.id, campaignId).subscribe(function (res1) {
            if (_this.isCampaignInvitationExisted(res1, influencer.id, campaignId)) {
                // check whether the influencer is confirmed
                _this.checkInfluencerConfirmation(_this.currentInfluencer);
                // Campaign influencer
                var campaignInfluencer = _this.campaignInfluencer = res1[0];
                if (_this.isReAccept) {
                    campaignInfluencer.status = CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name.toLowerCase();
                }
                else {
                    campaignInfluencer.status = campaignInfluencer.status;
                }
                _this.campaignInfluencerOriginalStatus = campaignInfluencer.status;
                campaignInfluencer.status = _this.calculateCampaignStatus(campaignInfluencer.status);
                _this.campaignInfluencerId = campaignInfluencer.campaign_influencer_id;
                // Slider
                _this.updateSlider(_this.campaignInfluencerOriginalStatus.toUpperCase());
                if ((campaignInfluencer.status === CampaignInfluencerStatus.DELETE || campaignInfluencer.status === CampaignInfluencerStatus.ACTIVE) && !isMobile) {
                    var actionDetail = campaignInfluencer.status === CampaignInfluencerStatus.DELETE ? ActionDetails.INFLUENCER_DECLINED_REQUEST : ActionDetails.INFLUENCER_ACCEPTED_REQUEST;
                    _this.sendMixpanelEvent(actionDetail, campaignInfluencer.campaign_id, campaignInfluencer.campaign_name);
                    return _this.router.navigate(['dashboard', 'campaigns', _this.campaignInfluencer.campaign_influencer_id, 'active']);
                }
                _this.getCampaignDetailData(campaignId, _this.campaignInfluencer);
            }
            else {
                if (AppSettings.isActiveNewCampaignFlow()) {
                    _this.showErrorPopup(InfluencerRequestError.CAMPAIGN_INVITATION_DELETE);
                }
                else {
                    _this.router.navigate(['dashboard', 'campaigns']);
                }
                _this.isDeletedOrError = true;
                _this.sendMixpanelEvent(ActionDetails.INFLUENCER_REQUEST_DELETE);
            }
        }, function (err) {
            _this.isDeletedOrError = true;
            _this.showErrorPopup(InfluencerRequestError.RETRIEVE_CAMPAIGN_INFO_FAIL);
        });
    };
    CampaignNewComponent.prototype.getCampaignDetailData = function (campaignId, campaignInfluencer) {
        var _this = this;
        this.newCampaignService.getCampaign(campaignId, campaignInfluencer.campaign_company_id).subscribe(function (res) {
            // Campaign
            _this.normalizeCampaignData(res, campaignInfluencer.status);
            // send MP event
            var actionDetail = _this.getMPActionDetail();
            _this.sendMixpanelEvent(actionDetail, _this.campaign.campaign.id, _this.campaign.campaign.name);
            // if campaign is archived, redirect to platform mode
            if (_this.campaign.campaign.status === CampaignInfluencerStatus.ARCHIVED) {
                _this.router.navigate(['dashboard', 'campaigns', campaignInfluencer.campaign_influencer_id, 'active']);
            }
        }, function (err) {
            if (err.error && err.error.data === 'campaign_not_found') {
                return Observable.of(null);
            }
            else {
                _this.isDeletedOrError = true;
                _this.showErrorPopup(InfluencerRequestError.RETRIEVE_CAMPAIGN_INFO_FAIL);
            }
        });
    };
    CampaignNewComponent.prototype.getMPActionDetail = function () {
        var actionDetail;
        if (this.campaign.campaign.status === CampaignInfluencerStatus.ARCHIVED) {
            actionDetail = ActionDetails.INFLUENCER_CAMPAIGN_ARCHIVED;
        }
        else if (this.campaignInfluencer.status === CampaignInfluencerStatus.NEW) {
            actionDetail = ActionDetails.INFLUENCER_OPEN_REQUEST;
        }
        else if (this.campaignInfluencerOriginalStatus.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase()) {
            actionDetail = ActionDetails.INFLUENCER_ACCEPTED_REQUEST;
        }
        else if (this.campaignInfluencerOriginalStatus.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name.toLowerCase()) {
            actionDetail = ActionDetails.INFLUENCER_DECLINED_REQUEST;
        }
        return actionDetail;
    };
    CampaignNewComponent.prototype.showErrorPopup = function (errorType) {
        this.errorType = errorType;
        this.modalService.openInCenter(this.warningFailToRetrieveCampaign, this.onDismissCampaignErrorModal.bind(this), 'fail-retrieve-camp', true);
    };
    CampaignNewComponent.prototype.sendMixpanelEvent = function (actionDetails, campaignId, campaignName, isAcceptOrRejectRequest) {
        var target = {
            type: TargetType.CAMPAIGN
        };
        if (campaignId && campaignName) {
            target = Object.assign({}, target, {
                id: campaignId,
                name: campaignName,
            });
        }
        if (!isAcceptOrRejectRequest) {
            this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CAMPAIGN_INVITATION, target, {
                actionDetails: actionDetails,
                source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
                campaignId: campaignId
            }, undefined, null);
        }
        else {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN_INVITATION, target, {
                actionDetails: actionDetails,
                source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
                campaignId: campaignId,
                action: UserActionType.UPDATE
            }, undefined, null);
        }
    };
    CampaignNewComponent.prototype.hideSideBar = function () {
        document.body.classList.add('no-sidebar');
    };
    CampaignNewComponent.prototype.showSideBar = function () {
        document.body.classList.remove('no-sidebar');
    };
    CampaignNewComponent.prototype.isCampaignInvitationExisted = function (campaignInfluencers, influencerId, campaignId) {
        if (!Array.isArray(campaignInfluencers) || campaignInfluencers.length === 0) {
            return false;
        }
        return campaignInfluencers.findIndex(function (ci) { return ci.campaign_id === campaignId && ci.influencer_id === influencerId; }) >= 0;
    };
    CampaignNewComponent.prototype.loadInfluencerConversation = function (campaignCompany, influencerId) {
        var _this = this;
        this.communicationService.fetchInfluencerConversation(campaignCompany, influencerId).subscribe(function (res) {
            _this.conversation = res;
        });
    };
    CampaignNewComponent.prototype.updateSlider = function (status) {
        this.campaignSlider = this.slider.slice(0); // Clone to new array
        this.campaignSlider.forEach(function (item) {
            item.selected = item.name === status;
        });
    };
    CampaignNewComponent.prototype.normalizeCampaignData = function (campaignData, status) {
        var additionalInformation = {
            content: campaignData.campaign.additionalInfo
        };
        var uploadMaterials = campaignData.files.map(function (f) { return ({
            image: f.fileUrl,
            name: f.fileName,
            id: f.id,
            contentType: f.contentType
        }); });
        var selectedTerms = campaignData.terms.map(function (st) { return ({
            id: st.id,
            summary: st.termSummary.content
        }); });
        this.campaign = {
            campaign: campaignData.campaign,
            influencerStatus: status,
            selectedTerms: selectedTerms,
            additionalInformation: additionalInformation,
            uploadMaterials: uploadMaterials
        };
    };
    CampaignNewComponent.prototype.onAcceptCampaign = function () {
        var _this = this;
        this.goToAllSetPage(true, true);
        this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name).then(function (success) {
            _this.updateSlider(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name);
            _this.sendMixpanelEvent(ActionDetails.INFLUENCER_ACCEPTED_REQUEST, _this.campaign.campaign.id, _this.campaign.campaign.name, true);
        }, function (error) {
            // Report to Sentry
            Sentry.captureException(error);
            return _this.goToAllSetPage(true, false);
        });
    };
    CampaignNewComponent.prototype.onDeclineCampaign = function (isFirstTime) {
        var _this = this;
        this.isFirstTime = isFirstTime;
        if (isFirstTime) {
            this.goToAllSetPage(false, null, true);
        }
        this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name).then(function (success) {
            _this.updateSlider(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name);
            _this.sendMixpanelEvent(ActionDetails.INFLUENCER_REJECTED_REQUEST, _this.campaign.campaign.id, _this.campaign.campaign.name, true);
            if (!_this.isFirstTime) {
                _this.back();
            }
        }, function (error) {
            if (_this.isFirstTime) {
                return _this.goToAllSetPage(false, null, false);
            }
            else {
                _this.back();
            }
            // Report to Sentry
            Sentry.captureException(error);
        });
    };
    CampaignNewComponent.prototype.onDismissCampaignErrorModal = function () {
        this.errorType = null;
    };
    CampaignNewComponent.prototype.requestNewInvitation = function () {
        var _this = this;
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (currentInfluencer) {
            this.influencerService.requestNewCampaignInvitation(currentInfluencer.id, this.campaignInfluencerId, RequestInfluencerType.CAMPAIGN_INVITATION)
                .subscribe(function (res) {
                _this.modalService.close();
                _this.router.navigate(['campaigns']);
            }, function (err) {
                _this.modalService.close();
                _this.router.navigate(['campaigns']);
            });
        }
    };
    CampaignNewComponent.prototype.tryAgainHandler = function (errorType) {
        if (!errorType) {
            return null;
        }
        if (errorType === InfluencerRequestError.CAMPAIGN_INVITATION_DELETE) {
            return this.requestNewInvitation();
        }
        else {
            return this.reloadPlatform();
        }
    };
    CampaignNewComponent.prototype.reloadPlatform = function () {
        this.modalService.close();
        return document.location.reload();
    };
    CampaignNewComponent.prototype.isShowRetryButton = function (errorType) {
        return errorType === InfluencerRequestError.RETRIEVE_CAMPAIGN_INFO_FAIL;
    };
    CampaignNewComponent.prototype.back = function () {
        return this.location.back();
    };
    CampaignNewComponent.prototype.isHideBottomBar = function () {
        return this.selectedTab === NewCampaignTabs.CHAT;
    };
    CampaignNewComponent.prototype.isShowButtonAccept = function () {
        return AppSettings.isActiveNewCampaignFlow() && this.campaignInfluencer
            && ("" + this.campaignInfluencer.status).toLocaleLowerCase() !== CampaignInfluencerStatus.ACTIVE.toLocaleLowerCase()
            && ("" + this.campaignInfluencer.status).toLocaleLowerCase() !== CampaignInfluencerStatus.ARCHIVED.toLocaleLowerCase();
    };
    CampaignNewComponent.prototype.isShowButtonDecline = function () {
        return AppSettings.isActiveNewCampaignFlow() && this.campaignInfluencer
            && ("" + this.campaignInfluencer.status).toLocaleLowerCase() !== CampaignInfluencerStatus.ACTIVE.toLocaleLowerCase()
            && ("" + this.campaignInfluencer.status).toLocaleLowerCase() !== CampaignInfluencerStatus.ARCHIVED.toLocaleLowerCase();
    };
    CampaignNewComponent.prototype.isEnableExportButton = function () {
        return this.campaignInfluencer && ("" + this.campaignInfluencer.status).toLocaleLowerCase() !== CampaignInfluencerStatus.NEW.toLocaleLowerCase();
    };
    CampaignNewComponent.prototype.isActivatedAdvertiserChat = function () {
        return !AppSettings.isDisableChat();
    };
    CampaignNewComponent.prototype.exportPDF = function () {
        this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
        this.pdfViewerService.generateCampaignPdf(this.campaignInfluencerId).subscribe();
    };
    CampaignNewComponent.prototype.closeNotification = function () {
        this.modalService.close();
    };
    CampaignNewComponent.prototype.calculateCampaignStatus = function (status) {
        var statusUppercase = ("" + status).toUpperCase();
        if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name
            || statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INTERESTED.name) {
            return CampaignInfluencerStatus.NEW;
        }
        else if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
            return CampaignInfluencerStatus.DELETE;
        }
        else {
            return CampaignInfluencerStatus.ACTIVE;
        }
    };
    CampaignNewComponent.prototype.updateInfluencerCampaignInvitation = function (status) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name) {
                _this.influencerService.acceptCampaignInvitation(_this.campaignId, _this.currentInfluencer.id)
                    .subscribe(function (res) {
                    resolve(res);
                }, function (error) {
                    reject(error);
                });
            }
            else if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
                _this.influencerService.declineCampaignInvitation(_this.campaignId, _this.currentInfluencer.id)
                    .subscribe(function (res) {
                    resolve(res);
                }, function (error) {
                    reject(error);
                });
            }
        });
    };
    CampaignNewComponent.prototype.goToAllSetPage = function (onAcceptCampaignInvitation, acceptionResult, declineResult) {
        var queryParams;
        if (onAcceptCampaignInvitation) {
            queryParams = {
                requestType: 'campaign_invitation',
                campaignInfluencerId: this.campaignInfluencerId,
                acceptionResult: acceptionResult,
                campaignId: this.campaignId,
                isNewCampaign: this.isNewCampaign,
                inviteToken: this.inviteToken
            };
        }
        else {
            queryParams = {
                requestType: 'campaign_invitation',
                campaignInfluencerId: this.campaignInfluencerId,
                declineResult: declineResult,
                campaignId: this.campaignId,
                isNewCampaign: this.isNewCampaign,
                isDeclined: true,
                inviteToken: this.inviteToken
            };
        }
        return this.router.navigate(['user', 'all-set'], {
            queryParams: queryParams
        });
    };
    CampaignNewComponent.prototype.setSelectedTab = function (tab) {
        this.selectedTab = tab;
    };
    CampaignNewComponent.prototype.setCampaingSelected = function () {
        this.selectedTab = NewCampaignTabs.CAMPAIGN;
    };
    CampaignNewComponent.prototype.setChatTabSelected = function () {
        this.selectedTab = NewCampaignTabs.CHAT;
        // Should load actual message here
        var currentInfluencer = this.userService.getInfluencerInfo();
        this.loadInfluencerConversation(this.campaign.campaign.companyId, currentInfluencer.id);
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
            id: TargetType.OPEN_CONTACT_TAB,
            name: TargetType.OPEN_CONTACT_TAB,
            type: TargetType.OPEN_CONTACT_TAB
        }, {
            source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP
        }, undefined, null);
    };
    CampaignNewComponent.prototype.isCampaignTabSelected = function () {
        return !!this.selectedTab && this.selectedTab === NewCampaignTabs.CAMPAIGN;
    };
    CampaignNewComponent.prototype.isChatTabSelected = function () {
        return !!this.selectedTab && this.selectedTab === NewCampaignTabs.CHAT;
    };
    Object.defineProperty(CampaignNewComponent.prototype, "showBottomBar", {
        get: function () {
            if (this.inviteToken || this.onMobile) {
                return false;
            }
            return this.selectedTab === NewCampaignTabs.CAMPAIGN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignNewComponent.prototype, "onMobile", {
        get: function () {
            return this.deviceService.isMobile();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignNewComponent.prototype, "isLandingPageMode", {
        get: function () {
            return this.inviteToken;
        },
        enumerable: true,
        configurable: true
    });
    return CampaignNewComponent;
}());
export { CampaignNewComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-new.component.ts.pre-build-optimizer.js